module.exports = __webpack_public_path__ + "static/media/linkedin.043df4cb.svg";